import React from 'react';
import sharedStyles from './ManagerShared.module.css';
import styles from './ManagerAttackingIntent.module.css';

export default function ManagerAttackingIntent({ intent }) {
    if (!intent) return null;

    const { xG, actualGoals } = intent;

    // Use a fixed max of 60 like in Figma, or dynamically scale if total is higher.
    const axisMax = Math.max(60, Math.ceil(Math.max(xG, actualGoals) / 20) * 20);

    const getWidth = (val) => `${(val / axisMax) * 100}%`;

    return (
        <section className={sharedStyles.section}>
            <h2 className={sharedStyles.sectionTitle}>Attacking Intent</h2>
            <div className={styles.container}>
                <span className={styles.comparisonLabel}>Comparison</span>

                <div className={styles.barsWrapper}>
                    <div className={styles.barRow}>
                        <div className={styles.barHeader}>
                            <span>xG</span> <span>{xG}</span>
                        </div>
                        <div className={styles.barBg}>
                            <div className={`${styles.barFill} ${styles.xgFill}`} style={{ width: getWidth(xG) }} />
                        </div>
                    </div>

                    <div className={`${styles.barRow} ${styles.barRowGoals}`}>
                        <div className={styles.barHeader}>
                            <span>Actual Goals</span> <span>{actualGoals}</span>
                        </div>
                        <div className={styles.barBg}>
                            <div className={`${styles.barFill} ${styles.goalsFill}`} style={{ width: getWidth(actualGoals) }} />
                        </div>
                    </div>
                </div>

                <div className={styles.axis}>
                    <span>0</span>
                    <span>{Math.round(axisMax * 0.5)}</span>
                    <span>{Math.round(axisMax * 0.75)}</span>
                    <span>{axisMax}</span>
                </div>
            </div>
        </section>
    );
}
